import CustomCamera from './CustomCamera';

export class CameraStandard extends CustomCamera {}
